module.exports = __webpack_public_path__ + "static/img/home_bg.1bdd74b1.png";